<template>
  <el-space>
    <el-button id="btnFM" :type="current===0?'primary':''" @click="openCurrent(0)">封面</el-button>
    <el-button id="btnBT" :type="current===1?'primary':''" @click="openCurrent(1)">标题</el-button>
    <el-button id="btnMS" :type="current===2?'primary':''" @click="openCurrent(2)">描述</el-button>
	<el-button id="btnDZ" :type="current===3?'primary':''" @click="openCurrent(3)">地址</el-button>
	<el-button id="btnYS" :type="current===4?'primary':''" @click="openCurrent(4)">医生</el-button>
	<el-button id="btnYYDT" :type="current===5?'primary':''" @click="openCurrent(5)">医院地图</el-button>
	<el-button id="btnGJC" :type="current===6?'primary':''" @click="openCurrent(6)">关键词</el-button>
	<el-button id="btnSCXM" :type="current===7?'primary':''" @click="openCurrent(7)">擅长项目</el-button>
	<el-button id="btnAXYLFW":type="current===8?'primary':''" @click="openCurrent(8)">安心医疗服务</el-button>
	<el-button id="btnYYZN" :type="current===9?'primary':''" @click="openCurrent(9)">预约指南</el-button>
	<el-button id="btnGZSJ" :type="current===10?'primary':''" @click="openCurrent(10)">工作时间</el-button>
  </el-space>

  <el-tour v-model="open" v-model:current="current">
    <el-tour-step
      target="#btnFM"
      title="编辑封面"
	  :next-button-props="nextClickProps"
    >
		<el-upload
			class="avatar-uploader"
			:limit="1"
			v-model:file-list="coverFileList"
			list-type="picture-card"
			action="https://server.walkertour.cn/hospital/info/uploadFile"
			:headers="headers"
			:data="coverData"
			multiple
			accept="image/png, image/jpeg"
			:on-success="handleCoverSuccess"
			:before-upload="beforeCoverUpload"
			:on-remove="handleCoverRemove"
			crossorigin="anonymous"
		>
			<el-icon class="avatar-uploader-icon"><Plus /></el-icon>
		</el-upload>
	</el-tour-step>
    <el-tour-step 
		target="#btnBT" 
		title="编辑标题" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerBt" :options="optionsBt" />
		</div>
		<br />
		<el-input class="w-50 m-2" v-model="bt[`${triggerBt}`]" />
	</el-tour-step>
	<el-tour-step
		target="#btnMS" 
		title="编辑描述" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerMs" :options="optionsMs" />
		</div>
		<br />
		<el-input class="w-50 m-2" v-model="ms[`${triggerMs}`]" />
	</el-tour-step>
	
	<el-tour-step
		target="#btnDZ" 
		title="编辑地址" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerDz" :options="optionsDz" />
		</div>
		<br />
		<el-input class="w-50 m-2" v-model="dz[`${triggerDz}`]" />
	</el-tour-step>
	
	<el-tour-step
		target="#btnYS" 
		title="编辑医生" 
		:next-button-props="nextClickProps"
	>
		<el-select
		    v-model="ysjs"
		    clearable
			filterable
			multiple
			collapse-tags
			collapse-tags-tooltip
		    placeholder="请选择"
		    style="width: 440px"
		  >
		    <el-option
		      v-for="item in options"
		      :key="item.value"
		      :label="item.label"
		      :value="item.value"
		    />
		  </el-select>
	</el-tour-step>
	
	<el-tour-step
		target="#btnYYDT" 
		title="编辑医院地图" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerDt" :options="optionsDt" />
		</div>
		<br />
		<el-upload
			class="avatar-uploader"
			:limit="1"
			v-model:file-list="fileList[`${triggerDt}`]"
			list-type="picture-card"
			action="https://server.walkertour.cn/hospital/info/uploadFile"
			:headers="headers"
			:data="data"
			multiple
			accept="image/png, image/jpeg"
			:on-success="handleAvatarSuccess"
			:before-upload="beforeAvatarUpload"
			:on-remove="handleDtRemove"
			crossorigin="anonymous"
		>
			<el-icon class="avatar-uploader-icon"><Plus /></el-icon>
		</el-upload>
	</el-tour-step>
	
	<el-tour-step
		target="#btnGJC" 
		title="编辑关键词" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerGjc" :options="optionsGjc" />
		</div>
		<br />
		<el-input-tag  tag-type="primary" v-model="gjcValue[`${triggerGjc}`]" trigger="Space" placeholder="请输入" />
	</el-tour-step>
	
	<el-tour-step
		target="#btnSCXM" 
		title="编辑擅长项目" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerScxm" :options="optionsScxm" />
		</div>
		<br />
		<el-input-tag tag-type="primary" v-model="scxmValue[`${triggerScxm}`]" trigger="Space" placeholder="请输入" />
	</el-tour-step>
	
	<el-tour-step
		target="#btnAXYLFW" 
		title="编辑安心医疗服务" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerAxylfw" :options="optionsAxylfw" />
		</div>
		<br />
		<el-input-tag v-model="axylfwValue[`${triggerAxylfw}`]" trigger="Space" placeholder="请输入" />
	</el-tour-step>
	
	<el-tour-step
		target="#btnYYZN" 
		title="编辑预约指南" 
		:next-button-props="nextClickProps"
	>
		<div>
			<el-segmented v-model="triggerYyzn" :options="optionsYyzn" />
		</div>
		<br />
		<el-input-tag v-model="yyznValue[`${triggerYyzn}`]" trigger="Space" placeholder="请输入" />
	</el-tour-step>
	
	<el-tour-step
		target="#btnGZSJ" 
		title="编辑工作时间" 
		:next-button-props="endClickProps"
	>
		<div>
			<el-segmented v-model="triggerGzsj" :options="optionsGzsj" />&nbsp;<el-button type="primary" @click="addSPaInfo">新增</el-button>
		</div>
		<br />
		<div v-for="(input, index) in gzsjItems[`${triggerGzsj}`]" :key="index" style="margin-top: 10px;width:92%;display: flex;align-items: center;">
		  <el-text class="mx-1" type="primary" style="width: 96px;">序号{{index+1}}</el-text>
		  <el-input v-model="input.name" placeholder="请输入星期"></el-input>&nbsp;
		  <el-input v-model="input.desc" placeholder="请输入时间段"></el-input>&nbsp;
		  <el-icon @click="delItem(index)"><Minus /></el-icon>
		</div>
	</el-tour-step>
  </el-tour>
</template>

<script setup>
	import { onBeforeUnmount, ref, shallowRef, onMounted, inject } from 'vue'
	import { ElMessage } from 'element-plus'
	import axios from 'axios';
	import { useMemberStore } from '../../../stores';
	const userStore = useMemberStore();
	const baseURL = 'https://devmini.walkertour.cn';
	const rootPath = "/www/wwwroot/testMiniServer/server/dist";
	const column = ['coverimage','bt','ms','dz','ysjs','dt','gjc','scxm','axylfw','yyzn','gzsj'];
	const headers = ref({
		'Authorization': `${userStore.profile?.token}`,
	})
	const data = ref({
		billid:`${userStore.profile?.userid}`
	})
	const defaultSelect = ref([])
	const current = ref(0)
	const stepClick=async()=>{
		let formValue = {};
		if(current.value===0){
			formValue['中文'] = coverImage.value;
			formValue['韩文'] = coverImage.value;
			formValue['英文'] = coverImage.value;
		}else if(current.value===1){
			formValue = bt.value; 
		}else if(current.value===2){
			formValue = ms.value;
		}else if(current.value===3){
			formValue = dz.value;
		}else if(current.value===4){
			formValue['中文'] = ysjs.value.toString();
			formValue['韩文'] = ysjs.value.toString();
			formValue['英文'] = ysjs.value.toString();
		}else if(current.value===5){
			formValue = dt.value;
		}else if(current.value===6){
			formValue = gjcValue.value
		}else if(current.value===7){
			formValue = scxmValue.value
		}else if(current.value===8){
			formValue = axylfwValue.value
		}else if(current.value===9){
			formValue = yyznValue.value
		}else if(current.value===10){
			formValue = gzsjItems.value
		}
		let response = await axios.post('/hospital/info/saveByColumn', {
		  billid:billid.value,
		  column:column[current.value],
		  formValue:JSON.stringify(formValue)
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			ElMessage.success("保存成功");
		}
	}
	const nextClickProps = ref({
		children:'保存',
		onClick:stepClick
	})
	const endClickProps = ref({
		children:'结束',
		onClick:stepClick
	})
	const delItem=(index)=>{
		gzsjItems.value[`${triggerGzsj.value}`].splice(index,1)
	}
	
	const openCurrent=(index)=>{
		current.value = index;
		open.value = true;
	}
	const open = ref(false)
	const bt = ref({'中文':'','韩文':'','英文':''})
	const ms = ref({'中文':'','韩文':'','英文':''})
	const dz = ref({'中文':'','韩文':'','英文':''})
	const dt = ref({'中文':'','韩文':'','英文':''})
	const ysjs = ref([])
	const create = ref('')
	const coverImage = ref('')
	const fileList = ref({'中文':[],'韩文':[],'英文':[]})
	const coverFileList = ref([])
	const coverData = ref({
		billid:`${userStore.profile?.userid}`,
		type:'coverImage'
	})
	const handleCoverSuccess= (
	  response,
	  uploadFile
	) => {
	  if(response.status===0){
		coverImage.value = response.imgUrl.replace(rootPath,baseURL);
	  }
	}
	
	const beforeCoverUpload = (rawFile) => {
	  if (rawFile.type !== 'image/jpg'&&rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
	    ElMessage.error('Avatar picture must be JPG/PNG format!')
	    return false
	  } else if (rawFile.size / 1024 / 1024 > 12) {
	    ElMessage.error('Avatar picture size can not exceed 12MB!')
	    return false
	  }
	  return true
	}
	const handleAvatarSuccess= (
	  response,
	  uploadFile
	) => {
	  if(response.status===0){
		dt.value[`${triggerDt.value}`] = response.imgUrl.replace(rootPath,baseURL);
	  }
	}
	
	const beforeAvatarUpload = (rawFile) => {
	  if (rawFile.type !== 'image/jpg'&&rawFile.type !== 'image/jpeg'&&rawFile.type !== 'image/png') {
	    ElMessage.error('Avatar picture must be JPG/PNG format!')
	    return false
	  } else if (rawFile.size / 1024 / 1024 > 12) {
	    ElMessage.error('Avatar picture size can not exceed 12MB!')
	    return false
	  }
	  return true
	}
	const optionsBt = ref(['中文','韩文','英文'])
	const triggerBt = ref('中文')
	//描述
	const optionsMs = ref(['中文','韩文','英文'])
	const triggerMs = ref('中文')
	//地址
	const optionsDz = ref(['中文','韩文','英文'])
	const triggerDz = ref('中文')
	//地图
	const optionsDt = ref(['中文','韩文','英文'])
	const triggerDt = ref('中文')
	//关键词 用于搜索
	const optionsGjc = ref(['中文','韩文','英文'])
	const triggerGjc = ref('中文')
	const gjcValue = ref({'中文':[],'韩文':[],'英文':[]})
	//擅长项目
	const optionsScxm = ref(['中文','韩文','英文'])
	const triggerScxm = ref('中文')
	const scxmValue = ref({'中文':[],'韩文':[],'英文':[]})
	//安心医疗服务
	const optionsAxylfw = ref(['中文','韩文','英文'])
	const triggerAxylfw = ref('中文')
	const axylfwValue = ref({'中文':[],'韩文':[],'英文':[]}) 
	//预约指南
	const optionsYyzn = ref(['中文','韩文','英文'])  
	const triggerYyzn = ref('中文')
	const yyznValue = ref({'中文':[],'韩文':[],'英文':[]}) 
	//工作时间
	const optionsGzsj = ref(['中文','韩文','英文'])
	const triggerGzsj = ref('中文')
	const gzsjItems = ref({'中文':[],'韩文':[],'英文':[]}) 
	const addSPaInfo=()=>{
		gzsjItems.value[`${triggerGzsj.value}`].push({
			name:'',
			desc:''
		})
	}
	const options = ref([])
	const billid = inject("billid");
	onMounted(async()=>{
		let response = await axios.post('/hospital/info/queryInfo', {
		  billid:billid.value,
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			coverImage.value = response.data.coverImage.length>0?response.data.coverImage[0].url:''
			bt.value = response.data.btValues
			ms.value = response.data.msValues
			dz.value = response.data.dzValues
			ysjs.value = response.data.ysjs.split(",")
			fileList.value = response.data.dtValues
			coverFileList.value = response.data.coverImage
			scxmValue.value = response.data.scxmValues
			axylfwValue.value = response.data.axylfwValues
			yyznValue.value = response.data.yyznValues
			gjcValue.value = response.data.gjcValues
			Object.keys(gzsjItems.value).forEach((item,index)=>{
				response.data.gzsjValues[`${item}`].map(data=>{
					gzsjItems.value[`${item}`].push({
						name:data.split(" ")[0],
						desc:data.split(" ").length>1?data.split(" ")[1]:''
					})
				})
				
			})
		}
		response = await axios.post('/doctor/info/queryInfoList', {
		  pageSize:1000,
		  pageNo:1
		}, {
		  headers: {
			'Content-Type': 'application/json',
			Authorization: `${userStore.profile?.token}`,
		  }
		});
		if(response.data.status===0){
			options.value = []
			response.data.data.map(item=>{
				options.value.push({
					label:item.xm,
					value:item.id
				})
			})
		}
		setTimeout(function(){
			open.value = true
		},300)
	})
	const handleCoverRemove=(file,uploadFiles)=>{
		coverImage.value = "";
	}
	
	const handleDtRemove=(file,uploadFiles)=>{
		dt.value[`${triggerDt.value}`] = "";
	}
</script>